import { Schema } from "effect";

export const WORKER_BINDING_RESOLVE_PATH = "/api/internal/worker-binding";
export const WORKER_BINDING_RESOLVE_HEADER = "x-workerstation-worker-binding";
export const WORKER_BINDING_CAPABILITY_PREFIX = "worker-binding-capability:v1:";

// Preserve the resolver's historical alphabet and 36-character header gate.
export const WorkerBindingToken = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[0-9a-f-]{36}$/i)).pipe(Schema.brand("WorkerBindingToken")))();
export type WorkerBindingToken = typeof WorkerBindingToken.Type;
export const WorkerBindingName = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[A-Za-z0-9_-]{1,64}$/)).pipe(Schema.brand("WorkerBindingName")))();
export type WorkerBindingName = typeof WorkerBindingName.Type;
export const WorkerBindingCapability = /* @__PURE__ */ (() => Schema.Struct({
  stationId: Schema.String, runtimeNamespaceId: Schema.optionalKey(Schema.String)
}))();
export type WorkerBindingCapability = typeof WorkerBindingCapability.Type;
export const WorkerBindingPrepared = /* @__PURE__ */ (() => Schema.Struct({
  workerName: Schema.String,
  workers: Schema.Record(Schema.String, Schema.Struct({
    workerName: Schema.String, exportName: Schema.optional(Schema.Json), props: Schema.optional(Schema.Json)
  }))
}))();
export type WorkerBindingPrepared = typeof WorkerBindingPrepared.Type;
export const WorkerBindingCatalog = /* @__PURE__ */ (() => Schema.Struct({
  workerName: Schema.String, bindings: Schema.Array(Schema.Struct({
    bindingName: Schema.String, workerName: Schema.String, exportName: Schema.optionalKey(Schema.String),
    props: Schema.optionalKey(Schema.Json), self: Schema.Boolean
  }))
}))();
export type WorkerBindingCatalog = typeof WorkerBindingCatalog.Type;
const OpaqueIdentity = /* @__PURE__ */ (() => Schema.String.check(Schema.isMinLength(1)))();
export const WorkerBindingTarget = /* @__PURE__ */ (() => Schema.Struct({
  workerId: OpaqueIdentity, anchorId: OpaqueIdentity, workerName: Schema.String
}))();
export type WorkerBindingTarget = typeof WorkerBindingTarget.Type;
export const WorkerBindingResolution = /* @__PURE__ */ (() => Schema.Struct({
  target: Schema.optional(WorkerBindingTarget), available: Schema.Array(Schema.String)
}))();
export type WorkerBindingResolution = typeof WorkerBindingResolution.Type;
